module.exports = __webpack_public_path__ + "img/director-work-icon4.8a4a8c99.png";